import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { useIntl } from 'ha/i18n';
import { SmartTrack as Track } from 'ha/components/track/SmartTrack';
import { Button, Grid, Typography } from '@hbf/dsl';
import { ListingCard } from 'ha/components/ListingCard';
import { NormalizedAlgoliaListing } from 'ha/models/Listing/types';

interface Props {
  city: string;
  cityLocalized?: string;
  pathToSearch: string;
  onClick: (pathToSearch: string) => void;
  listings: NormalizedAlgoliaListing[];
  isImperialSystem: boolean;
}

const useStyles = makeStyles()(theme => ({
  spacer: {
    padding: theme.spacing(1),
  },
  containerPadding: {
    padding: theme.spacing(6, 0),
  },
  alignCenter: {
    textAlign: 'center',
  },
}));

const ListingSimilarListings: React.FC<Props> = ({
  onClick,
  pathToSearch,
  city,
  cityLocalized,
  listings,
  isImperialSystem,
}) => {
  const { T } = useIntl();
  const { classes } = useStyles();

  const handleClick = React.useCallback(() => {
    onClick(pathToSearch);
  }, [onClick, pathToSearch]);

  return (
    <Grid
      container
      justifyContent="center"
      direction="column"
      className={classes.containerPadding}
    >
      <Grid item className={classes.alignCenter}>
        <Typography.H3>
          {T('similar_rooms_in')} {cityLocalized || city}
        </Typography.H3>
      </Grid>

      <div className={classes.spacer} />

      <Grid container item spacing={2}>
        {listings.map(listing => (
          <Grid item xs={12} sm={6} md={3} key={listing.id}>
            <Track name="Clicked Similar listing" type="button">
              <ListingCard
                room={listing}
                withGallery={false}
                linkTarget="_blank"
                isImperialSystem={isImperialSystem}
              />
            </Track>
          </Grid>
        ))}
      </Grid>

      <div className={classes.spacer} />

      <Grid container item justifyContent="center">
        <Grid item xs={12} className={classes.alignCenter}>
          <Track name="Clicked Find more rooms in city" type="button">
            <Button
              color="primary"
              variant="outlined"
              onClick={handleClick}
              data-test-locator="Find Similar Rooms"
            >
              {T('find_more_rooms_in')} {cityLocalized || city}
            </Button>
          </Track>
        </Grid>
      </Grid>
    </Grid>
  );
};

export { ListingSimilarListings };
